import { createApp } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import pinia from "@/app-store/initPinia";
import App from "./App.vue";
import "./utils/FontSetup";
import "animate.css";
import "./index.css";
import "./registerServiceWorker";
import router from "./router";
import Vue3Toastify from "vue3-toastify";
import "vue3-toastify/dist/index.css";

const app = createApp(App);
app.component("fa-icon", FontAwesomeIcon);
app.use(pinia);

app.use(router);
app.use(Vue3Toastify, {
  style: {
    "z-index": 9999,
    position: "fixed",
  },
});
app.mount("#app");
